// * GET
export const GET_INSURANCE_BROKERS = 'insuranceBroker/GET_INSURANCE_BROKERS';

// * SET
export const SET_INSURANCE_BROKERS = 'insuranceBroker/SET_INSURANCE_BROKERS';

// * FETCH
export const FETCH_INSURANCE_BROKERS =
  'insuranceBroker/FETCH_INSURANCE_BROKERS';

// * POST
export const POST_INSURANCE_BROKER = 'insuranceBroker/POST_INSURANCE_BROKER';

// * PUT
export const PUT_INSURANCE_BROKER = 'insuranceBroker/PUT_INSURANCE_BROKER';

// * DELETE
export const DELETE_INSURANCE_BROKER =
  'insuranceBroker/DELETE_INSURANCE_BROKER';
